<template>
  <router-view v-slot="{ Component }">
    <suspense>
      <component
        :is="Component"
      />
      <template #fallback>
        <splash />
      </template>
    </suspense>
  </router-view>
</template>

<script>
import { getAuthService } from '@/auth';

export default {
  name: 'App',
  inject: ['$hostStore'],
  props: {
    hostPath: {
      type: String,
      default: process.env.MFE_ROOT_ROUTE,
    },
  },
  async mounted() {
    const access_token = await getAuthService().getToken();

    if (access_token) {
      const currentRoute = this.$router.currentRoute.value;
      this.$router.replace({ path: this.hostPath, query: currentRoute.query });
    }
  },
};
</script>
